import { render } from "./TowersControls.vue?vue&type=template&id=34c5fd7a&scoped=true"
import script from "./TowersControls.vue?vue&type=script&lang=js"
export * from "./TowersControls.vue?vue&type=script&lang=js"

import "./TowersControls.vue?vue&type=style&index=0&id=34c5fd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c5fd7a"]])

export default __exports__